import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Button from 'react-bootstrap/Button';
import { servicesValidationSchema } from '../../validations-modules/hub.js'

import { FieldsServices } from '../fields-hub/FieldsServices.js'

export const FormServices = ({ formData, setFormData }) => {

  return (
    <>
      <Formik
        initialValues={formData}

        onSubmit={(values, {setSubmitting, resetForm}) => {
            // When button submits form and form is in the process of submitting, submit button is disabled
            setSubmitting(true);
            
            setFormData(prev => {
              return {...prev, ...values,
                submitCount: prev.submitCount+1}
            });

            // Resets form after submission is complete
            resetForm();

            // Sets setSubmitting to false after form is reset
            setSubmitting(false);

        }}

        validationSchema={servicesValidationSchema}
      >
        {({ isSubmitting, errors, touched, values, resetForm, handleSubmit, setFieldValue, setFieldTouched }) => 
        (
          <FieldsServices  handleSubmit={handleSubmit} touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched}>
                <div>
                <Button
                  type='submit'
                  variant='primary'
                  disabled={isSubmitting}
                  className="mr-1">
                  Salva
                </Button>
                <Button
                  type='button'
                  variant='primary'
                  onClick={() => resetForm()}
                  disabled={isSubmitting}
                  className="mr-1">
                  Annulla
                </Button>
              </div>  
        </FieldsServices>
        )}
      </Formik>
    </>
  );
};

FormServices.propTypes = {
  formData: PropTypes.object,
  setFormData: PropTypes.func.isRequired
};